module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/375.d3508d76.png";